import { act } from "react";
import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGIN_DATA_CLEAR,
  SIGNUP_REQUEST,
  SIGNUP_SUCCESS,
  SIGNUP_FAIL,
  ACHIEVE_SIGNUP_BONUS, 
  ACHIEVE_DAILY_REWARD
} from "../../constants/constants.js"

const initialState = {
  isAuthenticated: false,
  message: '',
  error: null,
  userData: {
    is_signup_bonus_achieved: false, 
    is_daily_reward_achieved: true
  },
};

const AuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        userData: action?.payload?.data?.user[0],
        message: action?.payload?.message,
        error: null,
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isAuthenticated: false,
        message: action?.payload?.message,
        error: action.payload,
      };
    case LOGIN_DATA_CLEAR:
      return {
        ...state,
        isAuthenticated: false,
        userData: {},
        message: '',
        error: null,
      };
    case SIGNUP_REQUEST:
      return {
        ...state,
      };
    case SIGNUP_SUCCESS:
      return {
        ...state,
        userData: action?.payload?.data?.user[0],
        message: action?.payload?.message,
        error: null,
      };
    case SIGNUP_FAIL:
      return {
        ...state,
        message: action?.payload?.message,
        error: action.payload,
      };
    case ACHIEVE_SIGNUP_BONUS: 
      return {
        ...state,
        userData: {
          ...state.userData,
          is_signup_bonus_achieved: true,
        },
      };

      case ACHIEVE_DAILY_REWARD: 
      return {
        ...state,
        userData: {
          ...state.userData,
          is_daily_reward_achieved: true,
        },
      };
    default:
      return state;
  }
};

export default AuthReducer;
